import Axios from "axios";
import { useContext, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardContext from "../../../../Context";

export default function ModalDeleteWorkDay({ showmodal, handelCloseModalDelete, idDay }) {

    const { urldashboard, authentication } = useContext(DashboardContext);

    const [loading, setLoading] = useState(false)

    const [dataDelete, setDataDelete] = useState({})

    const handeldelete = async () => {
        setLoading(true)
        try {
            const res = await Axios.delete(`${urldashboard}/workday/delete/${idDay}`, {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })

            const data = await res.data
            handelCloseModalDelete()
            setLoading(false)
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } catch (error) {
            //console.log(error);
            if (error.message === 'Network Error') {
                setDataDelete({ status: 500, message: 'اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(' })
                setLoading(false)
            }
            else {
                setDataDelete(error.response.data)
                setLoading(false)
            }

        }

    }


    return (
        <Modal show={showmodal} onHide={handelCloseModalDelete}>
            <Modal.Header >
                <Modal.Title>حذف روز کاری</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    loading ?
                        "درحال حذف منتظر باشید..."
                        :
                        dataDelete.hasOwnProperty("status") ?
                            dataDelete.message
                            : "ایا از حذف این روز کاری مطمئن هستید؟"
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={loading} className='ml-auto' onClick={handelCloseModalDelete}>خیر</Button>
                <Button variant="success" disabled={loading} onClick={handeldelete}>
                    {
                        loading ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "بله"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
